import { inject, Injectable, signal } from '@angular/core';
import { ZegoEngineService } from '../../../services/zego-engine.service';
import ZegoLocalStream from 'zego-express-engine-webrtc/sdk/code/zh/ZegoLocalStream.web';
import { ZegoExpressEngine } from 'zego-express-engine-webrtc';

@Injectable({
  providedIn: 'root'
})
export class CallZegoService {
  private zegoEngine: ZegoEngineService = inject(ZegoEngineService);

  engine: ZegoExpressEngine;

  private readonly _remoteStreams = signal<Record<string, MediaStream>>({});
  readonly remoteStreams = this._remoteStreams.asReadonly();

  constructor() {
    this.engine = this.zegoEngine.engine;
  }

  getEngine(): ZegoExpressEngine{
    return this.engine;
  }

  async loginRoom(
    roomID: string,
    userID: string,
    userName: string
  ): Promise<boolean> {
    return await this.zegoEngine.loginRoom(roomID, userID, userName);
  }

  logoutRoom(roomID: string): void {
    this.zegoEngine.logoutRoom(roomID);
  }


  async createAndPublishStream(
    userID: string,
    isCameraEnabled: boolean,
    isMicEnabled: boolean,
    type: 'audio' | 'video'
  ): Promise<{ localStream: ZegoLocalStream; streamID: string } | null> {
    if (!isCameraEnabled && !isMicEnabled) return null;
    try {
      const localStream = await this.engine.createZegoStream({
        camera: {
          video: isCameraEnabled ? {
            quality: 4,
            width: 960,
            height: 540,
            frameRate: 15
          } : false,
          audio: {
            ANS: isMicEnabled,
            AGC: isMicEnabled,
            AEC: isMicEnabled
        }
        },
        videoBitrate: 900,
        audioBitrate: 18,
      });
      // localStream.playAudio({enableAutoplayDialog: false});
      const streamID = `${userID}`;
      if(type === 'audio'){
        this.engine.mutePublishStreamVideo(localStream, true);
      }

      await this.engine.startPublishingStream(streamID, localStream, {
        enableTrafficControl: true,
        trafficControlFocusOnMode: 1,
        enableAutoSwitchVideoCodec: true
      });
      return { localStream, streamID };
    } catch (error) {
      console.error('Error creating and publishing stream:', error);
      throw error;
    }
  }

  stopPubishAndDestroyStream(stream: ZegoLocalStream | null, streamId: string){
    if(stream === null){
      return;
    }
    try{
      this.engine.stopPublishingStream(streamId);
      this.engine.destroyStream(stream)
    }catch(error){
      console.error("Clear local stream error:", error);
    }

  }

  setupStreamCallbacks(): void {
    // Notification of audio or video stream updates of other users in a room
    this.engine.on('roomStreamUpdate', async (roomID, updateType, streamList, extendedData) => {
      if (updateType == 'ADD') {
        streamList.forEach(async (streamInfo) => {
          try {
            const streamID = streamInfo.streamID;
            const userID = streamInfo.user?.userID || 'unknown';

            const remoteStream = await this.engine.startPlayingStream(streamID);
            this._remoteStreams.update((rs) => {return {...rs, [streamID]: remoteStream}})

            const videoElement = document.getElementById(`remote-stream`);
            if (videoElement) {
              const remoteView = this.engine.createRemoteStreamView(remoteStream);
              remoteView.play(videoElement, { enableAutoplayDialog: false, objectFit: 'cover' });
            }

          } catch (error) {
            console.error('Error adding remote stream:', error);
          }
        })
      } else if (updateType == 'DELETE') {
        // streamList.forEach(async (streamInfo) => { await this.removeRemoteStream(engine, streamInfo) });
      }
    });

    // this.engine.on('remoteCameraStatusUpdate', (streamID, status) => {
    // });

    // this.engine.on('remoteMicStatusUpdate', (streamID, status) => {
    // });

    // this.engine.on("soundLevelUpdate", (soundLevelList: ZegoSoundLevelInfo[]) => {
    //   soundLevelList.forEach(soundLevel => {
    //   })
    // })
  }

  toggleMicrophone(localStream: ZegoLocalStream | null, micState: boolean): boolean {
    if(!localStream) return false;
    this.engine.mutePublishStreamAudio(localStream, micState);
    return !micState;
  }

  toggleCamera(localStream: ZegoLocalStream | null, camState: boolean): boolean {
    if(!localStream) return false;
    this.engine.mutePublishStreamVideo(localStream, camState);
    return !camState;
  }
}
